import { BrowserRouter } from "react-router-dom";

import { SettingsProvider } from "./apps/publishing/context/SettingsContext";
import AppRoutes from "./routes/AppRoutes";

import "./styles/App.css";

export default function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
        <div className="App">
          <div className="pageContent">
            <AppRoutes />
          </div>
        </div>
      </SettingsProvider>
    </BrowserRouter>
  );
}